<div *ngIf="pendingOrders$ | async as pendingOrders" class="pending-orders">
  <mat-selection-list #selectedOrderIds [disableRipple]="true" class="pending-order-list">
    <ng-container *ngFor="let meshWithOrders of pendingOrders$ | async; trackBy: trackByIdFn">
      <div
        class="group-header"
        saAutomatedSelector="lmo_orders_pending__mesh_header"
        [automatedName]="meshWithOrders.type"
      >
        <mat-checkbox
          (change)="toggleMeshChecks($event, meshWithOrders.id)"
          *saAllowedAccountRoles="[1, 2, 9, 10]"
          saAutomatedSelector="lmo_orders_pending__mesh_checkbox"
        >
        </mat-checkbox>
        <span saAutomatedSelector="lmo_orders_pending__mesh_checkbox"> {{ meshWithOrders.type }} Mesh </span>
        <span saAutomatedSelector="lmo_orders_pending__order_count">{{
          meshWithOrders.orders.length | i18nPlural: loadPluralMapping
        }}</span>
      </div>
      <div class="order-group" *ngFor="let order of meshWithOrders.orders; trackBy: trackByIdFn" [@fadeInAndOut]="'in'">
        <mat-list-option
          class="order-checkbox"
          checkboxPosition="before"
          [value]="order"
          *saAllowedAccountRoles="[1, 2, 9, 10]"
        >
        </mat-list-option>
        <a class="pending-item" [routerLink]="['../', order.id]">
          <div class="header">
            <div class="load-number">
              <div class="flex items-center">
                {{ order.saUniqueId }}
                <img
                  *ngIf="order.boxPickupOORMiles"
                  class="w-4"
                  src="/assets/icons/box_move.svg"
                  alt="box move"
                  matTooltip="Box Move: {{ order.boxPickupOORMiles.siteName }}. Out of Route Miles: {{
                    order.boxPickupOORMiles.oorMiles
                  }} miles"
                />
              </div>
            </div>
            <div class="timestamp">
              <span *ngIf="isPending(order)">Sent {{ order.createTimestamp | ago }}</span>
              <span *ngIf="isDriverRejected(order)" class="red-text"
                >Rejected <span *ngIf="order?.user?.name">by {{ order.user.name }}</span></span
              >
            </div>
          </div>

          <div class="order-body">
            <div class="seq-number" saAutomatedSelector="lmo_orders_pending__load_number">
              Seq. #: {{ order.loadNumber }}
            </div>
            <ng-container *ngIf="isVorto()">
              <div
                class="text-red-500"
                *ngIf="(order.autoDispatchPaused && order.autoDispatchPauseEndsAt) || order.doNotAutoDispatch"
              >
                <div>AutoAssignment Paused</div>
                <div>Resuming in {{ order.autoDispatchPauseEndsAt | until: false }}</div>
              </div>
            </ng-container>
            <ng-container>
              <div class="urgent" *ngIf="order.boostPercent > 0">{{ order.boostPercent }}% Boost!</div>
              <div class="urgent" *ngIf="order.urgent && !order.boostPercent">
                Urgent
              </div>
              <div class="declined" *ngIf="order.orderStatus === 'declined'">
                Declined
              </div>
            </ng-container>
            <div class="up-for-grabs" *ngIf="order.isUpForGrabs && !order.urgent && !order.boostPercent">
              Up For Grabs
            </div>
            <div class="desc">
              {{ order.mesh.type }} Mesh<br />
              <div *saFeatureFlag="'orderTrailerType'">
                <div *ngIf="order.trailerType">Trailer Type: {{ order.trailerType?.trailerTypeDisplayName }}</div>
              </div>
              {{ order.vendor.name }} → {{ order.mine.site.name }} at
              {{ order.startTimestamp | date: 'shortTime' }}
            </div>
          </div>
        </a>
      </div>
    </ng-container>
  </mat-selection-list>
  <div class="actions-menu" *ngIf="selectedOrderIds.selectedOptions.selected.length && !(cancelling$ | async)">
    <div>{{ selectedOrderIds.selectedOptions.selected.length | i18nPlural: loadPluralMapping }} Selected</div>
    <div>
      <button
        mat-stroked-button
        color="warn"
        (click)="cancelOrders()"
        saAutomatedSelector="lmo_orders_pending__cancel_selected_button"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
